// assets/video-play.js

class CustomVideo extends HTMLElement {
  static currentlyPlaying = null;

  connectedCallback() {
    this.wrapper = this.querySelector('[data-video-wrapper]') || this;

    if (!this.wrapper) return;

    this.onClick = this.onClick.bind(this);

    this.wrapper.addEventListener('click', this.onClick);
  }

  showButton() {
    this.querySelector('[data-video-play]').classList.remove('jc-hidden');
  }

  hideButton() {
    this.querySelector('[data-video-play]').classList.add('jc-hidden');
  }

  stop(reset = false) {
    if (!this.video) return;
    this.video.pause();
    if (reset) {
      this.video.currentTime = 0;
      this.video.load(); // reload to show first frame as thumbnail
    }
    this.video.muted = true;
    this.showButton();
  }

  async play() {
    if (!this.video) return;

    // Stop any other video currently playing
    const other = CustomVideo.currentlyPlaying;
    if (other && other !== this) {
      other.stop(true);
    }
    CustomVideo.currentlyPlaying = this;

    // Try to play with sound first; fallback to muted if blocked
    this.video.muted = false;
    try {
      await this.video.play();
    } catch (e) {
      this.video.muted = true;
      try {
        await this.video.play();
      } catch (_) {}
    }

    this.hideButton();
  }

  onClick() {
    this.video = this.querySelector('video');
    this.video.playsInline = true;

    if (!this.video) return;

    if (this.video.paused) {
      this.play();
    } else {
      this.stop();
    }
  }
}

if (!customElements.get('custom-video')) {
  customElements.define('custom-video', CustomVideo);
}